import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-field-radio-list',
  templateUrl: './formly-field-radio-list.component.html',
  styleUrls: ['./formly-field-radio-list.component.scss'],
})
export class FormlyFieldRadioListComponent extends FieldType {}
